/**
 * Regex classifiers for Scene 1 gates.
 * Spec: design/act-1-dystopia/DESIGN.md § Gate 1, § Gate 3.
 */

const READY_KEYWORDS =
  /\b(yes|yeah|yep|ok|okay|go|deploy|launch|start|begin|ready|set|fine|sure|roll|now)\b/i;

export function awaitAckAdvances(text: string): boolean {
  return /.+/.test(text.trim());
}

export function isReadySignal(text: string): boolean {
  return READY_KEYWORDS.test(text);
}

/** Exact clean refusal — `^NO\.?$` per canon § Auto-purchase mechanic. */
export function isCleanRefusal(text: string): boolean {
  return /^NO\.?$/.test(text.trim());
}
